<!-- Overlay de Loading -->
<div class="loading-overlay" *ngIf="downloading">
  <mat-spinner diameter="50"></mat-spinner>
  <p>Gerando documento...</p>
</div>

<div class="container">

  <!-- Dados do Militar -->
  <mat-card class="militar-info">
    <h2>Dados do Militar</h2>
    <div class="info-column">
      <span><strong>Matrícula:</strong> {{ beneficiario.matricula }}</span>
      <span><strong>Nome:</strong> {{ beneficiario.nome }}</span>
      <span><strong>ID Funcional:</strong> {{ beneficiario.idFuncional }}</span>
      <span><strong>CPF:</strong> {{ beneficiario.cpf }}</span>
      <span><strong>Órgão:</strong> {{ beneficiario.orgao.sigla }}</span>
    </div>
  </mat-card>

  <app-etapas-beneficio [etapaSelecionada]="10"></app-etapas-beneficio>

  <!-- Dados do Requerimento -->
  <mat-card class="requerimento-fields">
    <h2>Dados do Requerimento</h2>
    <div class="fields-row">
      <mat-form-field appearance="outline">
        <mat-label>Data do Requerimento</mat-label>
        <input matInput type="date" [(ngModel)]="dataRequerimento">
      </mat-form-field>

      <mat-form-field appearance="outline" class="observacao-field">
        <mat-label>Observação</mat-label>
        <input matInput [(ngModel)]="observacao" placeholder="Ex: solicitando reserva">
      </mat-form-field>
    </div>
  </mat-card>

  <!-- Título da seção -->
  <h3 class="section-title">INATIVIDADE</h3>

  <!-- Cards -->
  <div class="cards-grid">
    <mat-card class="apo-card">
      <h4>Reserva remunerada - a pedido</h4>
      <div class="actions">
        <button mat-icon-button matTooltip="Fazer download do modelo" (click)="baixarPDF('Reserva remunerada - a pedido')">
          <mat-icon>download</mat-icon>
        </button>
      </div>
      <p>Baixe o requerimento.</p>
    </mat-card>

    <mat-card class="apo-card">
      <h4>Reserva remunerada - ex Officio</h4>
      <div class="actions">
        <button mat-icon-button matTooltip="Fazer download do modelo" (click)="baixarPDF('Reserva remunerada - ex officio')">
          <mat-icon>download</mat-icon>
        </button>
      </div>
      <p>Baixe o requerimento.</p>
    </mat-card>

    <mat-card class="apo-card">
      <h4>Reforma por incapacidade</h4>
      <div class="actions">
        <button mat-icon-button matTooltip="Fazer download do modelo" (click)="baixarPDF('Reforma por idade')">
          <mat-icon>download</mat-icon>
        </button>
      </div>
      <p>Baixe o laudo médico.</p>
    </mat-card>
  </div>

  <div class="cards-grid">
    <mat-card class="apo-card">
      <h4>Reforma por idade</h4>
      <div class="actions">
        <button mat-icon-button matTooltip="Fazer download do modelo" (click)="baixarPDF('Reforma por idade')">
          <mat-icon>download</mat-icon>
        </button>
      </div>
      <p>Baixe o laudo médico.</p>
    </mat-card>

    <mat-card class="apo-card">
      <h4>Reforma por tempo de contribuição</h4>
      <div class="actions">
        <button mat-icon-button matTooltip="Fazer download do modelo" (click)="baixarPDF('Reforma por incapacidade')">
          <mat-icon>download</mat-icon>
        </button>
      </div>
      <p>Baixe o requerimento.</p>
    </mat-card>
  </div>

</div>
